import { render, staticRenderFns } from "./TrainingRecordsSee.vue?vue&type=template&id=6bf9961e&scoped=true"
import script from "./TrainingRecordsSee.vue?vue&type=script&lang=js"
export * from "./TrainingRecordsSee.vue?vue&type=script&lang=js"
import style0 from "./TrainingRecordsSee.vue?vue&type=style&index=0&id=6bf9961e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf9961e",
  null
  
)

export default component.exports